import propTypes from 'prop-types'
import {Box, Icon} from '@chakra-ui/react'

import PrimaryProgressBar from './PrimaryProgressBar'

const PrimaryStep = ({title, icon, number, isCurrentStep, isPreviousStep}) => {
  const isCurrentOrPreviousStep = isCurrentStep || isPreviousStep

  return (
    <Box>
      <Box
        display="flex"
        alignItems="center"
        justifyContent="center"
        width="200px"
        fontSize="10px"
        textTransform="uppercase"
        fontWeight={isCurrentOrPreviousStep ? '400' : '500'}
        marginBottom="8px"
        color={isCurrentOrPreviousStep ? 'mld.neutral.800' : 'mld.neutral.1000'}
      >
        {icon && <Icon as={icon} marginRight="4px" />}
        {title}
      </Box>
      <Box display="flex" alignItems="flex-end">
        <PrimaryProgressBar isProgressed={isCurrentOrPreviousStep} />
        <Box
          width="20px"
          height="20px"
          flexShrink={0}
          borderRadius="full"
          textStyle="body-detail-medium"
          lineHeight="20px"
          margin="0 4px 0 4px"
          color={isCurrentOrPreviousStep ? 'mld.neutral.0' : 'mld.neutral.1000'}
          backgroundColor={
            isCurrentOrPreviousStep ? 'mld.neutral.1000' : 'mld.neutral.200'
          }
          textAlign="center"
        >
          {number}
        </Box>
        <PrimaryProgressBar isProgressed={isPreviousStep} />
      </Box>
    </Box>
  )
}

PrimaryStep.defaultProps = {
  icon: null,
}

PrimaryStep.propTypes = {
  title: propTypes.string.isRequired,
  icon: propTypes.func,
  number: propTypes.number.isRequired,
  isCurrentStep: propTypes.bool.isRequired,
  isPreviousStep: propTypes.bool.isRequired,
}

export default PrimaryStep
